import * as React from "react";
import type { SVGProps } from "react";
const SvgTarget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#target_svg__a)">
      <path d="M19.29 9.68h-3.98c-.55 0-1-.45-1-1V4.71c0-1.49 1.21-2.71 2.71-2.71 1.36 0 2.48 1 2.68 2.3C21 4.5 22 5.62 22 6.98c0 1.49-1.21 2.71-2.71 2.71zm-2.98-2h2.98c.39 0 .71-.32.71-.71s-.32-.71-.71-.71h-.57c-.55 0-1-.45-1-1v-.57c0-.39-.32-.71-.71-.71s-.71.32-.71.71v2.98z" />
      <path d="M12 13c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l8-8.01A.996.996 0 1 1 20.7 4.7l-7.99 8.01c-.2.2-.45.29-.71.29" />
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c1.38 0 2.72.28 3.98.82.51.22.74.81.52 1.31-.22.51-.81.74-1.31.52A7.9 7.9 0 0 0 12 3.99C7.59 4 4 7.59 4 12s3.59 8 8 8 8-3.59 8-8c0-1.11-.22-2.19-.67-3.2-.22-.51 0-1.09.52-1.32.5-.22 1.1 0 1.32.52.55 1.26.83 2.61.83 4 0 5.51-4.49 10-10 10" />
      <path d="M12 17.5A5.51 5.51 0 0 1 6.5 12c0-3.03 2.47-5.5 5.5-5.5 1.16 0 2.27.36 3.2 1.03.28.2.42.52.42.84.33 0 .64.13.84.42.68.94 1.04 2.05 1.04 3.22 0 3.03-2.47 5.5-5.5 5.5zm0-9c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5a3.504 3.504 0 0 0 2.84-5.55c-.13-.18-.19-.4-.19-.61-.18 0-.43-.05-.61-.19-.6-.43-1.3-.65-2.04-.65" />
    </g>
    <defs>
      <clipPath id="target_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTarget;
